import { faroCoreApiClient } from "@api/faro-core-api-client";
import { SPACE_ELEMENTS_OF_MODAL } from "@components/common/dialog/dialog-constants";
import { GroupAutoComplete } from "@components/common/group-autocomplete/group-autocomplete";
import { LabelWithHelp } from "@components/common/label-with-help";
import { MemberAutocomplete } from "@components/common/member-autocomplete/member-autocomplete";
import { useErrorContext } from "@context-providers/error-boundary/error-handling-context";
import { useHasUserValidFeatureCompanyLevel } from "@hooks/feature-control/use-has-user-valid-feature-company-level";
import { Stack } from "@mui-wrapper";
import { useEffect, useState } from "react";
/** List of groups and project managers with selecting ability */
export function GroupAndProjectManagerSelection({
  selectedGroupId,
  setSelectedGroupId,
  selectedProjectManager,
  setSelectedProjectManager,
  companyId
}) {
  const {
    handleErrorWithToast
  } = useErrorContext();
  const {
    canAssignManagers
  } = useHasUserValidFeatureCompanyLevel();
  const [groupMembers, setGroupMembers] = useState([]);

  // Triggered every time a group is selected.
  // It fetches the members that belong to that group and stores them
  // in the members variable.
  useEffect(() => {
    async function onGroupSelected(groupId) {
      // When the workspace cannot assign managers the manager selection is hidden, so there is
      // no need to fetch the group members (which would otherwise briefly block the user).
      if (!groupId || !canAssignManagers) {
        return undefined;
      }

      // As soon as you select a different group, empty the members array.
      // TODO: This should be moved to the group slice as createAsyncThunk: https://faro01.atlassian.net/browse/ST-698
      setGroupMembers([]);
      try {
        const {
          members
        } = await faroCoreApiClient.groups.getGroupById({
          companyId,
          groupId
        });
        const membersResult = members ?? [];
        setGroupMembers(membersResult);
      } catch (error) {
        handleErrorWithToast({
          id: `getGroupById-${Date.now().toString()}`,
          title: "Cannot get the group details",
          error
        });
      }
    }
    void onGroupSelected(selectedGroupId);
  }, [companyId, handleErrorWithToast, selectedGroupId, canAssignManagers]);
  return <>
      <Stack sx={{
      mb: SPACE_ELEMENTS_OF_MODAL
    }}>
        <LabelWithHelp title="Group" />
        <GroupAutoComplete callbackOnGroupSelected={setSelectedGroupId} selectedGroupId={selectedGroupId} placeholder="Please select a group..." />
      </Stack>
      {canAssignManagers && <Stack sx={{
      mb: SPACE_ELEMENTS_OF_MODAL
    }}>
          <LabelWithHelp title="Manager" isDisabled={!selectedGroupId} />
          <MemberAutocomplete members={groupMembers} selectedMember={selectedProjectManager} onOptionChange={setSelectedProjectManager} isDisabled={!selectedGroupId} placeholder="Choose who can manage this project..." />
        </Stack>}
    </>;
}